(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pointer-review-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateControls = (slider) => {
      const track = slider.querySelector('.jdgm-rev-widg__reviews');
      if (!track) return;
      const previous = slider.querySelector('[data-review-previous]');
      const next = slider.querySelector('[data-review-next]');
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum;
    };

    const initialise = (slider) => {
      const track = slider.querySelector('.jdgm-rev-widg__reviews');
      if (!track) return;
      track.setAttribute('role', 'region');
      track.setAttribute('aria-label', slider.dataset.reviewLabel);
      track.setAttribute('tabindex', '0');

      const reviews = Array.from(track.querySelectorAll('.jdgm-rev'));
      reviews.forEach((review, index) => {
        review.setAttribute('role', 'group');
        review.setAttribute('aria-label', `${slider.dataset.reviewLabel} ${index + 1} / ${reviews.length}`);
      });

      if (track.dataset.pointerReady !== 'true') {
        track.dataset.pointerReady = 'true';
        track.addEventListener('scroll', () => updateControls(slider), { passive: true });
      }
      updateControls(slider);
    };

    const start = () => document.querySelectorAll('[data-pointer-review-slider]').forEach(initialise);
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-previous], [data-review-next]');
      if (!button) return;
      const slider = button.closest('[data-pointer-review-slider]');
      const track = slider && slider.querySelector('.jdgm-rev-widg__reviews');
      if (!track) return;
      const direction = button.matches('[data-review-next]') ? 1 : -1;
      track.scrollTo({
        left: track.scrollLeft + direction * (track.clientWidth + 10),
        behavior: 'smooth'
      });
    });
    new MutationObserver(start).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', start, { passive: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pointer-visual-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.querySelector('[data-pointer-size-help-template]');
    if (!template) return;

    const injectSizeHelp = () => {
      document
        .querySelectorAll('[role="dialog"][aria-label="Size Chart"] .pify_size_chart_content[role="tabpanel"]')
        .forEach((panel) => {
          if (panel.querySelector('[data-pointer-size-help]')) return;
          panel.append(template.content.cloneNode(true));
        });
    };

    injectSizeHelp();
    new MutationObserver(injectSizeHelp).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
